(function () {
  'use strict';

  var sizeFilterName = 'filter.p.m.custom.case_measurement_';
  var priorities = {
    'availability': 0,
    'collection': 1,
    'movement': 2,
    'movement type': 2,
    'case measurement': 3,
    'case size': 3,
    'size': 3,
    'dial': 4,
    'material': 5,
    'gender': 6,
    'price': 7
  };

  var sizeRanges = [
    { id: '19-27', label: '19-27mm', min: 0, max: 28 },
    { id: '28-29', label: '28-29mm', min: 28, max: 30 },
    { id: '30-31', label: '30-31mm', min: 30, max: 32 },
    { id: '32-33', label: '32-33mm', min: 32, max: 34 },
    { id: '34-35', label: '34-35mm', min: 34, max: 36 },
    { id: '36-37', label: '36-37mm', min: 36, max: 38 },
    { id: '38-39', label: '38-39mm', min: 38, max: 40 },
    { id: '40-41', label: '40-41mm', min: 40, max: 42 },
    { id: '42-43', label: '42-43mm', min: 42, max: 44 },
    { id: '44-45', label: '44-45mm', min: 44, max: 46 },
    { id: '46-47', label: '46-47mm', min: 46, max: 48 },
    { id: '48-plus', label: '48mm+', min: 48, max: Infinity }
  ];

  var legacyGroupedValues = {};

  function normalizedLabel(button) {
    return (button && button.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function replaceButtonText(button, nextText) {
    var textNode = Array.prototype.find.call(button.childNodes, function (node) {
      return node.nodeType === 3 && node.textContent.trim();
    });

    if (!textNode) {
      var walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
      var candidate = walker.nextNode();
      while (candidate && !candidate.textContent.trim()) candidate = walker.nextNode();
      textNode = candidate;
    }

    if (textNode) textNode.textContent = nextText + ' ';
  }

  function unique(values) {
    return values.filter(function (value, index, array) {
      return array.indexOf(value) === index;
    });
  }

  function widthFromValue(value) {
    var normalized = String(value || '').trim();
    var measurementMatch = normalized.match(/\b(?:diameter|width)\s*(\d+(?:\.\d+)?)/i);
    if (measurementMatch) return Number(measurementMatch[1]);
    var leadingMatch = normalized.match(/^(\d+(?:\.\d+)?)/);
    return leadingMatch ? Number(leadingMatch[1]) : NaN;
  }

  function expandedValues(values) {
    var expanded = [];
    values.forEach(function (value) {
      if (legacyGroupedValues[value]) {
        expanded = expanded.concat(legacyGroupedValues[value]);
      } else {
        expanded.push(value);
      }
    });
    return unique(expanded);
  }

  function selectedSizeValues() {
    return expandedValues(new URL(window.location.href).searchParams.getAll(sizeFilterName));
  }

  function availableSizeValues(inputs) {
    var values = inputs.map(function (input) { return input.value; }).filter(function (value) {
      return value && !legacyGroupedValues[value];
    });

    Object.keys(legacyGroupedValues).forEach(function (groupedValue) {
      values = values.concat(legacyGroupedValues[groupedValue]);
    });

    return unique(values).filter(function (value) {
      return !Number.isNaN(widthFromValue(value));
    });
  }

  function applySizeSelection(list) {
    var values = [];
    list.querySelectorAll('input[type="checkbox"]:checked').forEach(function (checkbox) {
      values = values.concat(checkbox.gtjSizeValues || []);
    });

    var url = new URL(window.location.href);
    url.searchParams.delete(sizeFilterName);
    unique(values).forEach(function (value) {
      url.searchParams.append(sizeFilterName, value);
    });
    url.searchParams.delete('page');

    document.documentElement.classList.add('gtj-size-filter-loading');
    window.location.assign(url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash);
  }


  function sizeRangeForValue(value) {
    var width = widthFromValue(value);
    return sizeRanges.find(function (range) {
      return width >= range.min && width < range.max;
    });
  }

  function hrefWithoutSizeRange(selected, range) {
    var remaining = selected.filter(function (value) {
      return sizeRangeForValue(value) !== range;
    });
    var url = new URL(window.location.href);
    url.searchParams.delete(sizeFilterName);
    unique(remaining).forEach(function (value) {
      url.searchParams.append(sizeFilterName, value);
    });
    url.searchParams.delete('page');
    return url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash;
  }

  function enhanceActiveSizeTags() {
    var url = new URL(window.location.href);
    var rawSelected = url.searchParams.getAll(sizeFilterName);
    if (!rawSelected.length) return;

    var selected = expandedValues(rawSelected);
    var selectedRanges = sizeRanges.filter(function (range) {
      return selected.some(function (value) {
        return sizeRangeForValue(value) === range;
      });
    });

    document.querySelectorAll('.tag-list--active-tags').forEach(function (list) {
      list.querySelectorAll('a[href*="' + sizeFilterName + '"]').forEach(function (link) {
        var tag = link.closest('li') || link.parentNode;
        if (tag) {
          tag.hidden = true;
          tag.classList.add('gtj-size-filter__native-active-tag');
        }
      });

      var currentRangeIds = Array.prototype.map.call(list.querySelectorAll('.gtj-size-filter__active-tag'), function (tag) {
        return tag.dataset.gtjSizeRange || '';
      });
      var expectedRangeIds = selectedRanges.map(function (range) { return range.id; });
      if (currentRangeIds.join('|') === expectedRangeIds.join('|')) return;

      list.querySelectorAll('.gtj-size-filter__active-tag').forEach(function (tag) { tag.remove(); });
      selectedRanges.forEach(function (range) {
        var item = document.createElement('li');
        item.className = 'tag tag--remove gtj-size-filter__active-tag';
        item.dataset.gtjSizeRange = range.id;

        var link = document.createElement('a');
        link.className = 'btn btn--small';
        link.href = hrefWithoutSizeRange(selected, range);
        link.setAttribute('aria-label', 'Remove size ' + range.label + ' filter');
        link.appendChild(document.createTextNode(range.label));

        var remove = document.createElement('span');
        remove.className = 'gtj-size-filter__active-remove';
        remove.setAttribute('aria-hidden', 'true');
        remove.textContent = '×';
        link.appendChild(remove);

        item.appendChild(link);
        list.appendChild(item);
      });
    });

    var otherFilterCount = 0;
    url.searchParams.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0 && key !== sizeFilterName) otherFilterCount += 1;
    });

    document.querySelectorAll('button').forEach(function (button) {
      var match = (button.textContent || '').replace(/\s+/g, ' ').trim().match(/Filter \((\d+)\)/i);
      if (!match) return;

      var corrected = otherFilterCount + selectedRanges.length;
      var nextText = corrected ? 'Filter (' + corrected + ')' : 'Filter';
      var walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
      var textNode = walker.nextNode();

      while (textNode && !/Filter \(\d+\)/i.test(textNode.textContent)) {
        textNode = walker.nextNode();
      }

      if (textNode) {
        var currentText = textNode.textContent.match(/Filter \(\d+\)/i);
        if (!currentText || currentText[0] !== nextText) {
          textNode.textContent = textNode.textContent.replace(/Filter \(\d+\)/i, nextText);
        }
      }
    });
  }

  function buildSizeFilter(group) {
    group.classList.add('gtj-size-filter-group');
    if (group.dataset.gtjSizeEnhanced === 'true') return;

    var nativeInputs = Array.prototype.slice.call(group.querySelectorAll('input[type="checkbox"][name="' + sizeFilterName + '"]'));
    if (!nativeInputs.length) return;

    var nativeList = nativeInputs[0].closest('ul');
    var mount = nativeList ? nativeList.parentNode : group.querySelector('.collapsible-content__inner') || group;
    if (nativeList) {
      nativeList.hidden = true;
      nativeList.setAttribute('aria-hidden', 'true');
      nativeList.classList.add('gtj-size-filter__native');
    } else {
      nativeInputs.forEach(function (input) {
        var row = input.closest('li') || input.parentNode;
        if (row) row.hidden = true;
      });
    }

    var available = availableSizeValues(nativeInputs);
    var selected = selectedSizeValues();
    var list = document.createElement('ul');
    list.className = 'gtj-size-filter';
    list.setAttribute('aria-label', 'Filter watches by case size');

    sizeRanges.forEach(function (range) {
      var values = available.filter(function (value) {
        var width = widthFromValue(value);
        return width >= range.min && width < range.max;
      });
      if (!values.length) return;

      var item = document.createElement('li');
      item.className = 'gtj-size-filter__option';

      var checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.className = 'gtj-size-filter__checkbox';
      checkbox.id = 'gtj-size-' + range.id + '-' + Math.random().toString(36).slice(2, 8);
      checkbox.checked = values.some(function (value) { return selected.indexOf(value) !== -1; });
      checkbox.gtjSizeValues = values;

      var label = document.createElement('label');
      label.className = 'gtj-size-filter__label';
      label.htmlFor = checkbox.id;
      label.appendChild(checkbox);
      label.appendChild(document.createTextNode(range.label));

      checkbox.addEventListener('change', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        applySizeSelection(list);
      });

      item.appendChild(label);
      list.appendChild(item);
    });

    mount.appendChild(list);
    group.dataset.gtjSizeEnhanced = 'true';
  }

  function enhanceForm(form) {
    var groups = Array.prototype.slice.call(form.children).filter(function (child) {
      return child.className && String(child.className).indexOf('collection-sidebar__group--') !== -1;
    });

    groups.forEach(function (group) {
      var button = group.querySelector('.collapsible-trigger');
      var label = normalizedLabel(button);

      if (label === 'brand' || label === 'category') {
        group.hidden = true;
        group.setAttribute('aria-hidden', 'true');
        group.dataset.gtjFilterPriority = '99';
        return;
      }

      group.hidden = false;
      group.removeAttribute('aria-hidden');

      if (label === 'case measurement' || label === 'case size') {
        replaceButtonText(button, 'Size');
        label = 'size';
      }

      if (label === 'movement type') {
        replaceButtonText(button, 'Movement');
        label = 'movement';
      }

      if (label === 'size') buildSizeFilter(group);

      group.dataset.gtjFilterPriority = String(
        Object.prototype.hasOwnProperty.call(priorities, label) ? priorities[label] : 50
      );
    });

    var ordered = groups.slice().sort(function (a, b) {
      return Number(a.dataset.gtjFilterPriority) - Number(b.dataset.gtjFilterPriority);
    });
    var alreadyOrdered = ordered.every(function (group, index) {
      return groups[index] === group;
    });
    if (!alreadyOrdered) ordered.forEach(function (group) { form.appendChild(group); });
  }

  var scheduled = false;
  function enhanceFilters() {
    if (scheduled) return;
    scheduled = true;
    Promise.resolve().then(function () {
      scheduled = false;
      document.querySelectorAll('.filter-form').forEach(enhanceForm);
      enhanceActiveSizeTags();
    });
  }


  var lifestyleHoverImages = {
  "breitling-navitimer-b01-chronograph-43-mm-ab0138241g1p1": {
    "url": "https://cdn.shopify.com/s/files/1/0676/7879/8041/files/ab0138241g1p1-on-wrist_9334ee8c_thumbnail_2048.webp?v=1769534751",
    "alt": "Breitling Navitimer B01 Chronograph 43 AB0138241G1P1 on the wrist"
  },
  "breitling-navitimer-b01-chronograph-43-mm-ab01381e1g1p1": {
    "url": "https://cdn.shopify.com/s/files/1/0676/7879/8041/files/Breitling_Navitimer_B01_Chronograph_43_mm_AB01381E1G1P1_wrist.webp?v=1772420953",
    "alt": "Breitling Navitimer B01 Chronograph 43 AB01381E1G1P1 on the wrist"
  }
};

  function imageUrlAtWidth(url, width) {
    try {
      var imageUrl = new URL(url, window.location.origin);
      imageUrl.searchParams.set('width', String(width));
      return imageUrl.toString();
    } catch (error) {
      return url;
    }
  }

  function applyLifestyleHoverImages(root) {
    (root || document).querySelectorAll('.grid-product').forEach(function (card) {
      if (card.dataset.gtjBreitlingLifestyleApplied === 'true') return;
      var productLink = card.querySelector('a[href*="/products/"]');
      if (!productLink) return;
      var match = productLink.getAttribute('href').match(/\/products\/([^?#/]+)/);
      if (!match || !lifestyleHoverImages[match[1]]) return;

      var images = card.querySelectorAll('img');
      if (images.length < 2) return;

      var secondary = images[1];
      var lifestyle = lifestyleHoverImages[match[1]];
      var widths = [360, 540, 720, 900, 1080];
      secondary.srcset = widths.map(function (width) {
        return imageUrlAtWidth(lifestyle.url, width) + ' ' + width + 'w';
      }).join(', ');
      secondary.src = imageUrlAtWidth(lifestyle.url, 540);
      secondary.alt = lifestyle.alt;
      secondary.loading = 'lazy';
      card.classList.add('gtj-breitling-card');
      card.dataset.gtjBreitlingLifestyleApplied = 'true';
    });
  }

  function init() {
    enhanceFilters();
    applyLifestyleHoverImages(document);
    new MutationObserver(function () { enhanceFilters(); applyLifestyleHoverImages(document); }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
}());
